import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Input, PageHead, useToast } from '@w7/ui'
import { sessionApi } from '@/api/sessionApi'

export function RateCategoryPage() {
  const toast = useToast()
  const navigate = useNavigate()
  const [name, setName] = useState('')

  return (
    <div>
      <PageHead title="Rate Category" onBack={() => navigate('/sessionmarket')} />
      <div className="sm-card">
        <label>
          Rate Category
          <div className="sm-row" style={{ marginTop: 8 }}>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              style={{ flex: 1 }}
            />
            <Button
              variant="primary"
              onClick={() =>
                void sessionApi
                  .saveRateCategory({ name })
                  .then(() => {
                    toast.success('Rates category saved successfully')
                    setName('')
                  })
                  .catch((err: { response?: { status?: number; data?: { message?: string } } }) => {
                    if (err?.response?.status === 412) {
                      toast.error('Rate category already exist')
                      setName('')
                    } else {
                      toast.error(err?.response?.data?.message ?? 'Something went wrong')
                      setName('')
                    }
                  })
              }
            >
              Submit
            </Button>
          </div>
        </label>
      </div>
    </div>
  )
}
